@for (dropdown of state.dropdowns; track dropdown; let i = $index) {
  <mat-form-field>
    <mat-label>{{ dropdown.label }}</mat-label>
    <mat-select
      [formControl]="state.dropdowns.length > 1 || state.multipleDropdowns  ? $any(state.form.get(i.toString())) : state.form"
      [multiple]="state.multi">
      @for (option of dropdown.options; track option) {
        <mat-option
          [disabled]="state.multi && isOptionDisabled(i, option.value)"
          [value]="option.value">
          <span>{{ option.name }}</span>
          @if (option.subtitle) {
            <span class="oo-subtitle">{{ option.subtitle }}</span>
          }
        </mat-option>
      }
    </mat-select>
    @if (dropdown.hint) {
      <mat-hint align="end">{{ dropdown.hint }}</mat-hint>
    }
    <mat-error>Required</mat-error>
  </mat-form-field>
}
